import React from "react";
import PropTypes from "prop-types";
import _ from "underscore";
import { usePrevious } from "@evertrue/et-components";
import { useCachedByIdResource, useCachedById } from "./use-cached-by-id-resource";

const ETCachedUserContext = React.createContext();

const useETCachedUserById = id => {
  const { dataById, idsLoading, fetchIfNotCached } = React.useContext(ETCachedUserContext);
  useCachedById(id, fetchIfNotCached);
  return { user: dataById[id] || {}, loading: idsLoading[id] };
};

const useETCachedUsersByIds = ids => {
  const { fetchIfNotCached, dataById, idsLoading, fetchById, addToCache } = React.useContext(ETCachedUserContext);
  const prev_ids = usePrevious(ids);

  React.useEffect(() => {
    const new_ids = _.difference(ids, prev_ids);
    if (new_ids.length) {
      // this endpoint is limited by 100, so split into chunks
      const chunks = _.chunk(new_ids, 100);
      chunks.forEach(fetchIfNotCached);
    }
  });

  const loading = ids.filter(id => idsLoading[id]);
  return { allUsersById: dataById, idsLoading: loading, fetchById, addToCache };
};

const normalize = data => {
  return _.indexBy(data.users, "id");
};

const ETCachedUserByIdProvider = ({ fetchUsersById, children }) => {
  // TODO: add role ids?
  const value = useCachedByIdResource(userIds => fetchUsersById({ userIds }), normalize);
  return <ETCachedUserContext.Provider value={value}>{children}</ETCachedUserContext.Provider>;
};

ETCachedUserByIdProvider.propTypes = {
  children: PropTypes.any,
  fetchUsersById: PropTypes.func,
};

export { ETCachedUserByIdProvider, useETCachedUsersByIds, useETCachedUserById };

export default ETCachedUserContext;
